import { render, staticRenderFns } from "./MenuRectangleHistoryFilled.vue?vue&type=template&id=cbd41098"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports